import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { StateService } from 'src/app/shared/services/state.service';
import { DefinitionTypeBC, DefinitionNamesBC } from 'src/app/shared/typeBCDefinitions';

export interface DialogData {
  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  result: boolean;
}

export class modalData {
  currentSociety: SocieteModel;
  currentType: any;
}

interface TypeBC {
  value: string;
  label: string;
}

@Component({
  selector: 'app-select-society-modal',
  templateUrl: './select-society-modal.component.html',
  styleUrls: ['./select-society-modal.component.scss']
})

export class SelectSocietyModalComponent implements OnInit {

  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  societyList: SocieteModel[];
  definitionTypeBC = DefinitionTypeBC;
  definitionNamesBC = DefinitionNamesBC;
  typesBc: TypeBC[] = [
    { value: this.definitionTypeBC.BCStandard, label: "Commande " + this.definitionNamesBC.BCStandard },
    { value: this.definitionTypeBC.BCEnveloppe, label: "Commande "  + this.definitionNamesBC.BCEnveloppe}
  ];
  selectForm: UntypedFormGroup;
  society = '';
  @Input() idSociety: number;
  info: modalData = new modalData();
  constructor(public dialog: MatDialog,
              private societyService: SocieteService,
              public router: Router,
              private fb: FormBuilder,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private state: StateService) {

      this.selectForm = this.fb.group({
                  society: ['', Validators.required],
                  typeBc: ['', Validators.required]
      });    
      this.societyService.getAllForCreateBc().subscribe(obj => {
      this.societyList = obj;
      //Stop skipping the pop up to chose if bc standard or enveloppe
      // // On passe le choix si la personne a les droits sur une seule société
      // if (this.societyList.length === 1) {
      //   this.info.currentSociety = this.societyList[0];
      //   this.info.currentType = this.typesBc[0].value;
      //   this.onModalConfirm();
      // }
      // else if (localStorage.getItem('societe')){
      //   // Si la personne vient de créer un bc, on passe
      //   this.info.currentSociety = JSON.parse(localStorage.getItem('societe'));
      //   this.info.currentType = this.typesBc[0].value;
      //   localStorage.removeItem('societe');
      //   this.onModalConfirm();
      // }
      const idSoc = JSON.parse(localStorage.getItem('CURRENT_USER')).idSociete;
      // si la societe de l'utilisateur courant existe dans la liste alors on la met par defaut!
      var res = this.societyList.find(soc => soc.id === idSoc);
      if (res) {
        this.selectForm.controls.society.setValue(`${res.code}-${res.libelle}`);
        this.info.currentSociety = res;
      }
    });
  }

  ngOnInit(): void {
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.icon_color = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.color = this.data.color;
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    this.data.result = true;
    this.dialogRef.close(this.info);
    this.state.changeSociety(this.info.currentSociety);
  }

  updateSociety(event): void {
    if (event) {
      this.info.currentSociety = event;
    } else {
      this.info.currentSociety = null;
    }
  }
  updateTypeBc(event):void {
    if(event){
      this.info.currentType = event.value;
    }
  }

}
